import React from 'react';
import { Box, Grid } from '@mui/material';
import { TourCardSkeletonV2 } from 'views/rebranded-module/common/components';

const ToursListingSectionSkeleton = () => (
  <Box py={3}>
    <Grid container spacing={2}>
      {Array(10).fill(0).map((_, item) => (
        <Grid
          key={item}
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          xl={2.4}
          xxl={2.4}
        >
          <TourCardSkeletonV2 />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export { ToursListingSectionSkeleton };
